export default {
    'title': {
        ru: 'Менеджеры',
        en: 'Managers',
    },
    'emptyList': {
        ru: 'Нет ответственных менеджеров',
        en: 'Contractor hasn\'t attached managers',
    },
    'attaching': {
        ru: 'Привязка менеджера',
        en: 'Manager attaching',
    },
    'editing': {
        ru: 'Редактирование менеджера',
        en: 'Manager edition',
    },
    'attach': {
        ru: 'Привязать',
        en: 'Attach',
    },
    'user': {
        ru: 'Пользователь',
        en: 'User',
    },
    'comment': {
        ru: 'Комментарий',
        en: 'Comment',
    },
    'detach': {
        ru: 'Отвязать',
        en: 'Detach',
    },
    'detachConfirm': {
        ru: 'Вы уверены, что хотите отвязать менеджера?',
        en: 'Are you sure want to detach manager?',
    },
}